<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Iniflow Invoices Monthly Report</h1>
  </div>
  <div *ngIf="message" class="alert alert-warning">{{ messageDesc }}</div>
  <div class="row">
    <div class="col-md-auto">
      <mat-form-field>
        <mat-label>Select Month for generating invoices Report</mat-label>
        <input
          matInput
          [matDatepicker]="leaveEndDate"
          required
          (dateChange)="fetchInvoiceReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaveEndDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaveEndDate></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Employee Name"
        #input
      />
    </mat-form-field>

    <table
      mat-table
      [dataSource]="invoiceDataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="peppolInvoiceId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Peppol Invoice id"
        >
          Peppol Invoice ID
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.peppolInvoiceId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by invoiceId id"
        >
          NISH Invoice ID
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.invoiceId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="iniflowCustomerId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by customer id"
        >
          Customer
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.iniflowCustomerId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="empName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Employee and contract"
        >
          Employee Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.empName }}</td>
      </ng-container>
      <ng-container matColumnDef="clientName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by customer name"
        >
          Customer Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
      </ng-container>
      <ng-container matColumnDef="contractCompanyName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by contractCompanyName"
        >
          Contract Company Name
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.contractCompanyName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="reference">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Employee and contract"
        >
          Employee / Contract
        </th>
        <td mat-cell *matCellDef="let element">{{ element.reference }}</td>
      </ng-container>
      <ng-container matColumnDef="totalAmount">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by totalAmount"
        >
          Total Amount
        </th>
        <td mat-cell *matCellDef="let element">{{ element.totalAmount }}</td>
      </ng-container>
      <ng-container matColumnDef="invoiceDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Invoice Date"
        >
          Invoice Date
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceDate }}</td>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Due Date"
        >
          Due Date
        </th>
        <td mat-cell *matCellDef="let element">{{ element.dueDate }}</td>
      </ng-container>
      <ng-container matColumnDef="invoiceType">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by invoiceType"
        >
          Invoice Type
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceType }}</td>
      </ng-container>
      <ng-container matColumnDef="sentOn">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by sentOn"
        >
          sent On
        </th>
        <td mat-cell *matCellDef="let element">{{ element.sentOn }}</td>
      </ng-container>
      <ng-container matColumnDef="sentBy">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by sentBy"
        >
          Sent By
        </th>
        <td mat-cell *matCellDef="let element">{{ element.sentBy }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>

  <app-progress [loading$]="loading$"> </app-progress>
</div>
